<script setup lang="ts">
import { inject } from 'vue'

import { AccordionContextSymbol } from '@/components/Accordion/context'

const { title } = defineProps<{
  title?: string
  isLoading?: boolean
}>()

const accordeonContext = inject(AccordionContextSymbol)

if (!accordeonContext)
  throw new Error('Accordeon context not found')

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)

const { isOpen } = accordeonContext
</script>

<template>
  <div
    flex
    items-center
    justify-between
    w-full
    gap-2.5
    text-gray-500
    p-2
    py-2.5
    pl-4
    h-12
    transition-colors
  >
    <div class="flex items-center gap-2 font-inter">
      <span flex items-center flex-shrink-0>
        <slot name="icon" />
      </span>

      <p class="font-bold text-softBlack text-sm">
        {{ capitalize(title || '') }}
      </p>
    </div>
    <!-- actions -->
    <div class="flex items-center gap-2">
      <slot name="actions" />
      <div
        i-material-symbols:keyboard-arrow-down
        :class="$style.arrow_icon"
        :rotate="isOpen ? 360 : 270"
      />
    </div>
  </div>
</template>

<style module lang="css">
.arrow_icon {
      @apply w-9 h-9 text-dark-gray;
      transition: transform 0.3s ease-in-out;
      pointer-events: none !important;
    }
</style>
